module.exports = __webpack_public_path__ + "static/media/SavedSearch-white.9401bcd7.svg";